import { render, staticRenderFns } from "./alumno-ligado.vue?vue&type=template&id=100cb38e&"
import script from "./alumno-ligado.component.ts?vue&type=script&lang=ts&"
export * from "./alumno-ligado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports